<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Resend Confirmation</title>
</svelte:head>

<script>
  import Form from '@components/forms'
  import Message from '@components/general/message.svelte'
  import { Link, useForm } from '@inertiajs/svelte'
  import { CircleCheck } from 'lucide-svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'

  const form = useForm({
    email_address: ''
  })

  let sent = $state(false)

  function handleSubmit(e) {
    e.preventDefault()
    sent = false
    $form.post('/user_confirmation', { onSuccess: () => sent = true })
  }
</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
    <!-- Logo -->
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-32" />
    </div>

    <!-- Heading -->
    <h1 class="text-3xl font-serif text-center text-gray-700 mb-10">Confirm your email</h1>

    {#if sent}
      <Message type="info" Icon={CircleCheck}>
        <p>If an account exists with this email address, a confirmation email has been sent.</p>
      </Message>
    {:else}
      <Form.Element {form} id="user-confirmation-form" class="auth-form" onsubmit={handleSubmit} allowEnterSubmit>

        <Form.Items class="gap-6">
          <Form.Item name="email_address" label="Email address" type="email" placeholder="your-email@company.com" bind:value={$form.email_address} validate={false} required autofocus />
        </Form.Items>

        <Form.Submit class="submit mt-8 flex-1 w-full justify-center" text="Resend confirmation email" loading={$form.processing} />

      </Form.Element>
    {/if}
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    <Link href="/session/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Back to sign in</Link>
  </div>
</div>
